type Border = 'none' | `${number}px solid`

const definition = {
    none: 'none',
    thin: '1px solid',
    thick: '2px solid',
} satisfies Record<string, Border>

export const sideBorders: { [K in keyof typeof definition]: Border } = definition
